import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { EXPERIMENT_TWO_TEXT_MAX_LENGTH } from '../../validation/validationRules';

export const CareerDevelopmentDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  return (
    <Textarea
      id="careerDevelopmentDetails"
      label="In what ways are you being supported to advance your skills and career?"
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={EXPERIMENT_TWO_TEXT_MAX_LENGTH}
    />
  );
};
